import axios from 'axios';
import axiosRetry from 'axios-retry';

// const baseURL = 'https://zinpro-backend.herokuapp.com/api/'
export const baseURL = process.env.VUE_APP_API_URL;

// export const baseURL = 'https://sgp1.zinprofirststep.com/api/';

const instance = axios.create({
  baseURL,
  timeout: 8000,
});

axiosRetry(instance, {
  retries: 2,
  retryDelay: (retryCount) => {
    return retryCount * 1000;
  },
  retryCondition: (error) => {
    // Don't retry when offline — navigator.onLine is false or it's a network error with no response
    if (!navigator.onLine) return false;
    return axiosRetry.isNetworkOrIdempotentRequestError(error);
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },

  (error) => {
    return Promise.reject(error);
  },
);

export default instance;